import { Icon } from "@iconify/react/dist/iconify.js";
import { SignUpContext } from "../AuthContext/SignUpContext";
import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const roles = [
  { id: "admin", name: "admin" },
  { id: "CRO", name: "CRO" },
  { id: "DFO", name: "DFO" },
];


const SignUpLayer = () => {
  const useSignUp = useContext(SignUpContext);
  const { signup } = useSignUp;
  const [departments, setDepartments] = useState([]);
  const [signUpData, setSignUpData] = useState({
    firstname: "",
    lastname: "",
    phoneno: "",
    email: "",
    password: "",
    confirmpassword: "",
    address: "",
    designation: "1",
    role: "",
    department: "",
    emergency_contact_name: "",
    emergency_contact_number: "",
    emergency_contact_address: "",
    imageUrl: "",
  });

  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  const [passwordValid, setPasswordValid] = useState(true);
  const [passwordMatchError, setPasswordMatchError] = useState("");

  const handleImageChange = async (e) => {
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const file = e.target.files[0];
    if (!file) return;
  
    try {
      // Create form data for the upload
      const formData = new FormData();
      formData.append('photos', file);
      formData.append('uploadPath', 'profile');
      formData.append('fileName', `user_${Date.now()}`); // Unique filename
  
      // Upload the image
      const uploadResponse = await fetch(`${API_BASE_URL}/backend/upload`, {
        method: 'POST',
        body: formData,
      });
  
      if (!uploadResponse.ok) {
        throw new Error('Image upload failed');
      }
  
      const uploadData = await uploadResponse.json();
      
      // Get the thumbnail URL from the response
      const thumbnailUrl = uploadData.uploadResponses[0].data[0].availableSizes.thumbnail;
      
      // Set preview and update form data
      setImagePreviewUrl(thumbnailUrl);
      setSignUpData((prevData) => ({ 
        ...prevData, 
        imageUrl: thumbnailUrl 
      }));
      
      toast.success('Image uploaded successfully');
    } catch (error) {
      console.error('Image upload error:', error);
      toast.error('Failed to upload image');
    }
  };

  const handleSignUpChange = (e) => {
    const { name, value } = e.target;
    setSignUpData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      if (name === "password" || name === "confirmpassword") {
        setPasswordValid(updatedData.password.length >= 8);
        setPasswordMatchError(
          updatedData.password !== updatedData.confirmpassword
            ? "Passwords do not match."
            : ""
        );
      }

      return updatedData;
    });
  };
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_BE_API_URL}/backend/departments/get-all-departments`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setDepartments(response.data.data);
      } catch (error) {
        toast.error("Failed to fetch departments.");
        console.error("Error fetching departments:", error);
      }
    };
    fetchDepartments();
  }, []);
 
  const handleSignUp = async (e) => {
    e.preventDefault();

    // Validate all required fields
    const requiredFields = [
      'firstname', 'lastname', 'phoneno', 'email', 'password',
      'address', 'department', 'role', 'emergency_contact_name',
      'emergency_contact_number', 'emergency_contact_address'
    ];

    const missingFields = requiredFields.filter(field => !signUpData[field]);
    if (missingFields.length > 0) {
      toast.error(`Missing required fields: ${missingFields.join(', ')}`);
      return;
    }

    try {
      const backendData = {
        username: `${signUpData.firstname}_${signUpData.lastname}`.toLowerCase().replace(/\s+/g, '_'),
        first_name: signUpData.firstname,
        last_name: signUpData.lastname,
        phone_no: signUpData.phoneno,
        email: signUpData.email,
        password: signUpData.password,
        address: signUpData.address,
        designation: signUpData.designation || "1", // Ensure default value
        role: signUpData.role, // Ensure lowercase
        department: signUpData.department,
        emergency_contact_name: signUpData.emergency_contact_name,
        emergency_contact_number: signUpData.emergency_contact_number,
        emergency_contact_address: signUpData.emergency_contact_address,
        imageUrl: signUpData.imageUrl
      };


      const result = await signup(backendData);
      
      if (result?.success) {
        toast.success("User created successfully!");
        // Reset form or redirect
      } else {
        toast.error(result?.message || "Failed to create user");
      }
    } catch (error) {
      console.error("Signup error:", error);
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };
  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
       <ToastContainer />
      <form onSubmit={handleSignUp} >
        <div className="text-center mb-6">
          <h6 className="mb-4 text-3xl font-extrabold text-gray-800 flex items-center justify-center bg-gray-100 p-4 rounded-lg shadow-md">
            <Icon icon="mdi:account-plus" className="text-4xl mx-3 my-1" />
            Add New User Form
          </h6>
        </div>

        <div className="row gy-3">
          {[
            { label: "First Name", name: "firstname", icon: "mdi:account" },
            { label: "Last Name", name: "lastname", icon: "mdi:account" },
            { label: "Phone Number", name: "phoneno", icon: "mdi:phone" },
            { label: "Email", name: "email", icon: "mdi:email", type: "email" },
            { label: "Emergency Contact Name", name: "emergency_contact_name", icon: "mdi:account" },
            { label: "Emergency Contact Number", name: "emergency_contact_number", icon: "mdi:phone" },
            { label: "Emergency Contact Address", name: "emergency_contact_address", icon: "mdi:home" },
          ].map(({ label, name, icon, type = "text" }) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={name}>
              <label className="form-label d-flex align-items-center gap-2">
                <Icon icon={icon} className="text-lg" />
                {label}
              </label>
              <input
                type={type}
                name={name}
                value={signUpData[name]}
                onChange={handleSignUpChange}
                className="form-control h-56-px bg-neutral-50 radius-12 shadow-sm"
                placeholder={label}
                required
              />
            </div>
          ))}

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:office-building" className="text-lg" />
              Department
            </label>
            <select
              name="department"
              value={signUpData.department}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 d-flex align-items-center shadow-sm"
              required
            >
              <option value="">Select Department</option>
              {departments.map((dept) => (
                <option key={dept.id} value={dept.id}>
                  {dept.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:account-star" className="text-lg" />
              Role
            </label>
            <select
              name="role"
              value={signUpData.role}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 d-flex align-items-center shadow-sm"
              required
            >
              <option value="">Select Role</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>

          {/* <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:briefcase" className="text-lg" />
              Designation
            </label>
            <select
              name="designation"
              value={signUpData.designation}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 d-flex align-items-center shadow-sm"
              required
            >
              <option value="">Select Designation</option>
              {designations.map((designation) => (
                <option key={designation.id} value={designation.id}>
                  {designation.name}
                </option>
              ))}
            </select>
          </div> */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:lock" className="text-lg" />
              Password
            </label>
            <input
              type="password"
              name="password"
              value={signUpData.password}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 shadow-sm"
              placeholder="Enter Password"
              required
            />
            {!passwordValid && (
              <span className="text-danger ms-3">Password must be at least 8 characters long.</span>
            )}
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:lock-check" className="text-lg" />
              Confirm Password
            </label>
            <input
              type="password"
              name="confirmpassword"
              value={signUpData.confirmpassword}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 shadow-sm"
              placeholder="Confirm Password"
              required
            />
            {passwordMatchError && <span className="text-danger">{passwordMatchError}</span>}
          </div>
          
          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:home" className="text-lg" />
              Address
            </label>
            <textarea
              name="address"
              className="form-control bg-neutral-50 radius-12 shadow-sm"
              rows={4}
              placeholder="e.g., House No. 123, Street No. 4, Forest Colony Lahore"
              value={signUpData.address}
              onChange={handleSignUpChange}
            />
          </div>

          <div className="mb-24 mt-16 col-lg-4 col-md-6 col-sm-12">
            <div className="avatar-upload">
              <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                <input
                  type="file"
                  id="imageUpload"
                  accept=".png, .jpg, .jpeg"
                  hidden
                  onChange={handleImageChange}
                />
                <label
                  htmlFor="imageUpload"
                  className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle">
                  <Icon icon="solar:camera-outline" className="icon"></Icon>
                </label>
              </div>
              <div className="avatar-preview">
                <div
                  id="imagePreview"
                  style={{
                    backgroundImage: imagePreviewUrl ? `url(${imagePreviewUrl})` : '',
                  }}
                >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button
            className="btn btn-success text-sm btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-3 col-md-6 col-sm-12"
            type="submit"
            disabled={!passwordValid || passwordMatchError}
          >
            Add New User
          </button>
        </div>
      </form>
    </div>
  );
};

export default SignUpLayer;